module.exports = __webpack_public_path__ + "img/P8.ea8a9b48.png";